//同步吸顶和非吸顶时候的两个组件实例化对象
const _sdata = {
  order: null,
  column: {
    first_day_gain: true,
    gray_pct_change: true,
    listing_date: false,
    latest: true,
    issue_price: true,
    gain_since_listed: true,
  }, // 每一列默认排列方式
  pre: null,
};
const isNotShowTab = !Number(window.F10Utils.getUrlParams('isNotShowTab'))

// 信息展示组件
export function Display(Vue) {
  const options = {
    props: ['list', 'textAlgin'],
    template: `
            <div class="display">
                <div class="display__row flex ai-c jc-sb" v-for="(row, index) in list" :key="row.label">
                    <div class="display__label gray-text1">{{row.label}}<i :class="row.icon" class="ml-4" v-if="row.icon" @click="$emit('clickicon', row)"></i></div>
                    <div class="display__value">{{row.value || '--'}}</div>
                </div>
            </div>`,
  };
  Vue.component('display', options);
}

export function StockList(Vue) {
  let Scroller = null;
  const options = {
    props: ['list', 'unit', 'fixed', 'expand', 'menuHeight', 'sortMethod'],
    data() {
      return {
        props: [],
        propKeys: {},
        actTh: 'listing_date',
        showShadow: false,
        preExpandRow: null,
        showFixedHead: false,
      };
    },
    mounted() {
      window.$('#tab-container').on('click', () => {
        this.showFixedHead = this.setShowFixedHead();
      });
      window.addEventListener('scroll', evt => {
        if (evt.target !== document) return;
        this.showFixedHead = this.setShowFixedHead();
        if (this.showFixedHead) {
          this.$nextTick(() => {
            const fixedHeadScroller = this.$refs.fixedHeadScroller;
            const stockListScroller = this.$refs.stockListScroller;
            fixedHeadScroller.scrollLeft = stockListScroller.scrollLeft;
          });
        }
      });
    },
    methods: {
      setShowFixedHead() {
        const stockList = this.$refs.stockList;
        const domTop = window.$('#tab-container').height();
        let blockHeight = 0;
        // 适配组件在a股打新日历中的情况
        if (isNotShowTab) {
          const domBlock = document.getElementById('hkStock-calendar-block-ipo');
          blockHeight = domBlock ? domBlock.getBoundingClientRect().height : 0;
        }
        if (!stockList) return;
        //const bdTop = stockList.getBoundingClientRect().top - blockHeight - domTop;
        const bdTop = window.$('#listed').offset().top - window.$(window).scrollTop() - blockHeight - domTop;

        return bdTop < 0;
      },
      sort(order, prop) {
        const flag = order ? -1 : 1;
        if (this.sortMethod) {
          this.sortMethod(order, prop);
        } else {
          if (prop === 'listing_date') {
            this.list.sort((pre, next) => {
              return flag * (pre[prop] < next[prop] ? 1 : -1);
            });
          } else {
            this.list.sort((pre, next) => {
              return flag * (parseFloat(next[prop]) - parseFloat(pre[prop]));
            });
          }
        }
      },
    },
    // 列表组件
    render(h) {
      const expandRow = row => {
        if (this.preExpandRow && this.preExpandRow !== row) {
          this.preExpandRow.expand = false;
        }
        row.expand = !row.expand;
        this.preExpandRow = row;
      };
      const menu = scope => {
        return h(
          'div',
          {
            class: 'stock-list-menu',
            style: `height: ${this.menuHeight}`,
          },
          [this.$slots.default[0].data.scopedSlots.menu(scope)]
        );
      };
      const leftThead = h(
        'thead',
        {
          class: 'stock-list-lth',
        },
        [h('tr', {}, [this.$slots.default[0]])]
      );
      const leftTbody = this.list.map(row => {
        let content = h('p', row[this.props[0].key]);
        if (this.$slots.default[0].componentOptions.children) {
          content =
            this.$slots.default[0].componentOptions.children[0].data.scopedSlots.default(row);
        }
        return h(
          'tr',
          {
            on: {
              click: () => {
                expandRow(row);
              },
            },
          },
          [
            h(
              'td',
              {},
              row.expand
                ? [
                    h(
                      'div',
                      {
                        style: `padding-bottom: ${this.menuHeight}`,
                      },
                      [content]
                    ),
                    menu(row),
                  ]
                : [h('div', {}, [content])]
            ),
          ]
        );
      });

      const leftTable = h(
        'table',
        {
          class: ['stock-list-ltb', this.showShadow && 'stock-list-shadow'],
        },
        [leftThead, h('tbody', {}, leftTbody)]
      );
      const rightSlots = this.$slots.default.filter((slot, index) => index && slot.tag);
      const rightProps = this.props.slice(1);
      const rightThead = h(
        'thead',
        {
          class: 'stock-list-rth',
        },
        [h('tr', {}, rightSlots)]
      );
      const rightTableWidth = this.props.reduce((pre, next) => {
        return pre + parseFloat(next.labelWidth);
      }, 0);
      const rightTbody = this.list.map(row => {
        const cells = rightSlots.map((slot, index) => {
          const key = rightProps[index] && rightProps[index].key;
          let content = h('p', row[key]);
          if (slot.componentOptions.children) {
            content = slot.componentOptions.children[0].data.scopedSlots.default(row);
          }
          return h(
            'td',
            {},
            row.expand
              ? [
                  h(
                    'div',
                    {
                      style: `padding-bottom: ${this.menuHeight}`,
                    },
                    [content]
                  ),
                ]
              : [h('div', {}, [content])]
          );
        });
        return h(
          'tr',
          {
            on: {
              click: () => {
                expandRow(row);
              },
            },
          },
          cells
        );
      });
      const rightTable = h(
        'table',
        {
          class: 'stock-list-rtb',
          style: `width: ${rightTableWidth + (this.unit || 'rem')}`,
        },
        [rightThead, h('tbody', {}, rightTbody)]
      );
      // 适配组件在ipo中的场景
      const fixedClass = isNotShowTab ? ['stock-list stock-list-fixedhead stock-list-fixedhead-ipo sub-bg-card'] : ['stock-list stock-list-fixedhead sub-bg-card'];
      const fixedHead = h(
        'div',
        {
          class: fixedClass,
          ref: 'fixedHead',
        },
        [
          h(
            'table',
            {
              class: 'stock-list-ltb',
            },
            [leftThead]
          ),
          h(
            'div',
            {
              class: 'stock-list-scroller',
              ref: 'fixedHeadScroller',
              on: {
                scroll: evt => {
                  if (!Scroller) {
                    Scroller = evt.target;
                  } else if (Scroller !== evt.target) {
                    Scroller = null;
                    return;
                  }
                  const scrollLeft = evt.target.scrollLeft;
                  const stockListScroller = this.$refs.stockListScroller;
                  stockListScroller.scrollLeft = scrollLeft;
                  if (scrollLeft) {
                    this.showShadow = true;
                  } else {
                    this.showShadow = false;
                  }
                },
              },
            },
            [
              h(
                'table',
                {
                  class: 'stock-list-rtb',
                  style: `width: ${rightTableWidth + (this.unit || 'rem')}`,
                },
                [rightThead]
              ),
            ]
          ),
        ]
      );

      const scroller = h(
        'div',
        {
          class: 'stock-list-scroller',
          ref: 'stockListScroller',
          on: {
            scroll: evt => {
              if (!Scroller) {
                Scroller = evt.target;
              } else if (Scroller !== evt.target) {
                Scroller = null;
                return;
              }
              const scrollLeft = evt.target.scrollLeft;
              if (this.showFixedHead) {
                const fixedHeadScroller = this.$refs.fixedHeadScroller;
                fixedHeadScroller.scrollLeft = scrollLeft;
              }
              if (scrollLeft) {
                this.showShadow = true;
              } else {
                this.showShadow = false;
              }
            },
          },
        },
        [rightTable]
      );
      return h(
        'div',
        {
          class: ['stock-list sub-bg-card'],
          ref: 'stockList',
        },
        this.showFixedHead ? [fixedHead, leftTable, scroller] : [leftTable, scroller]
      );
    },
  };
  Vue.component('stock-list', options);
}

// 列表项
export function StockListItem(Vue) {
  let pre = null;
  const options = {
    props: ['prop', 'label', 'labelWidth', 'sortable'],
    watch: {
      column: {
        handler(nv, ov) {
          console.log(nv, ov);
        },
        deep: true,
      },
    },
    data() {
      return _sdata;
    },
    template: `
            <th :style="{width: labelWidth}" class="gray-text2" @click="if(prop === 'stock_name' || prop == null) return;$parent.actTh = prop ; updateOrder();$parent.sort(order, prop)">
                {{label}}
                <div class="stock-list-sort" v-if="sortable && $parent.actTh === prop">
                    <div class="stock-list-sort-ascending" v-if="order" ></div>
                    <div class="stock-list-sort-dscending" v-if="!order" ></div>
                </div>
            </th>`,
    methods: {
      // 修改排序方式
      updateOrder() {
        console.log('uuu')
        pre !== this.prop && (this.column[pre] = true);
        let key = '';
        for (key in this.column) {
          if (key === this.prop) {
            if (pre) {
              this.column[key] = !this.column[pre];
            } else {
              this.column[key] = !this.column[this.prop];
            }
            pre = key;
            this.order = this.column[key];
          } else {
            this.column[key] = true;
          }
        }
      },
    },
    mounted() {
      if (this.$parent.propKeys[this.prop]) return;
      this.$parent.propKeys[this.prop] = true;
      this.$parent.props.push({
        key: this.prop,
        label: this.label,
        labelWidth: this.labelWidth,
        sortable: this.sortable,
      });
    },
  };
  Vue.component('stock-list-item', options);
}
